// @ts-strict-ignore
import type { ReasonCode, ReasonCodeGroup, Threshold } from 'flow/store/engine/types';
import type { ReasonCodeServiceCodeKey } from './types';


export function getReasonCodeGroupName(
  reasonCodeGroupId: number,
  reasonCodeGroups: ReasonCodeGroup[],
) {
  return reasonCodeGroups.find(({ id }) => id === reasonCodeGroupId).name;
}

export function indexReasonCodeGroupsById(
  reasonCodeGroups: ReasonCodeGroup[],
): Record<ReasonCodeGroup['id'], ReasonCodeGroup> {
  return Object.fromEntries(
    reasonCodeGroups.map(reasonCodeGroup => [reasonCodeGroup.id, reasonCodeGroup]),
  );
}

export function indexReasonCodeGroupsByName(
  reasonCodeGroups: ReasonCodeGroup[],
): Record<ReasonCodeGroup['name'], ReasonCodeGroup> {
  return Object.fromEntries(
    reasonCodeGroups.map(reasonCodeGroup => [reasonCodeGroup.name, reasonCodeGroup]),
  );
}

export function indexReasonCodesByServiceCodeKey(
  reasonCodes: ReasonCode[],
): Record<ReasonCodeServiceCodeKey, ReasonCode> {
  return Object.fromEntries(
    reasonCodes.map(reasonCode => [createReasonCodeServiceCodeKey(reasonCode), reasonCode]),
  );
}


export function createReasonCodeServiceCodeKey(reasonCode: ReasonCode): ReasonCodeServiceCodeKey {
  return `${reasonCode.service_internal_name}::${reasonCode.code}`;
}


export function getHighestReasonCodeGroupId(
  reasonCodeGroups: ReasonCodeGroup[],
): ReasonCodeGroup['id'] {
  if (reasonCodeGroups.length === 0) {
    return 0;
  }
  return Math.max(...reasonCodeGroups.map(rcg => rcg.id));
}


export function isReasonCodeGroupReferencedInAnyThreshold(args: {
  reasonCodeGroup: ReasonCodeGroup;
  thresholds: Record<Threshold['publicId'], Threshold>;
}): boolean {
  const { reasonCodeGroup, thresholds } = args;

  return Object.values(thresholds)
    .some(threshold => threshold.right?.reasonCodeGroupId === reasonCodeGroup.id);
}


export function isReasonCodeGroupEphemeral(reasonCodeGroup: ReasonCodeGroup): boolean {
  return reasonCodeGroup?.isEphemeral ?? false;
}


export function getReasonCodeGroupFromThreshold(threshold: Threshold): ReasonCodeGroup | null {
  return threshold.right?.reasonCodeGroup ?? null;
}
